import { Col, Row } from 'antd';
import React from 'react';
import styled, { css } from 'styled-components';
import { CpBody01Primary } from 'components/atoms/customer-portal/typography';
import { FieldValueEditor } from './field-value-editor';
import { CpTaskDrawerFieldProps } from './types';

const LabelCol = styled(Col)`
  display: flex;
  align-items: center;
`;
const Label = styled(CpBody01Primary)`
  color: var(--cp-gray-100);
`;
const NoBorderCss = css`
  .ozone-select__control,
  > .ant-input,
  > .ant-picker,
  .cp-select-input-field {
    border-bottom: none !important;
  }
  .ozone-select__indicator-separator,
  .ozone-select__dropdown-indicator,
  .cp-select-input-dropdown-indicator,
  .cp-select-input-indicator-seperator {
    display: none;
  }
`;

const ValueCol = styled(Col)`
  ${NoBorderCss};
`;

const ReadonlyValueCol = styled(Col)`
  display: flex;
  align-items: center;
  .progress-bar-input {
    padding-left: var(--cp-spacing-03);
  }
  ${NoBorderCss};
`;

const StyledRow = styled(Row)`
  margin-bottom: var(--cp-spacing-05);
  width: 100%;
  min-height: 42px;

  @media (max-width: 480px) {
    flex-direction: column;

    margin-bottom: var(--cp-spacing-06);

    .ant-col-6,
    .ant-col-18 {
      max-width: 100% !important;
      width: 100% !important;
      flex: 0 0 100% !important;
    }

    ${LabelCol} {
      width: 100%;
      margin-bottom: var(--cp-spacing-03);
    }

    ${ValueCol} {
      width: 100%;
    }
  }
`;

export const CpTaskDrawerField: React.FC<CpTaskDrawerFieldProps> = ({
  field,
  onChange,
}) => {
  return (
    <StyledRow>
      <LabelCol span={6}>
        <Label>{field?.fieldLabel}</Label>
      </LabelCol>
      <ValueCol span={18}>
        <FieldValueEditor field={field} onChange={onChange} />
      </ValueCol>
    </StyledRow>
  );
};

export const CpTaskDrawerReadonlyField: React.FC<{
  label: React.ReactNode;
  value: React.ReactNode;
}> = ({ label, value }) => {
  return (
    <StyledRow>
      <LabelCol span={6}>
        <CpBody01Primary>{label}</CpBody01Primary>
      </LabelCol>
      <ReadonlyValueCol span={18}>{value}</ReadonlyValueCol>
    </StyledRow>
  );
};
